export default function getPublicUrl() {
  return window.location.origin;
}
